import { useTranslation } from "react-i18next";
import { notificationCodes } from "./SettingsSyncToCalHelper";

export default function SettingsNotification({ type, errorCode, onClearNotification, message }) {
    const { t } = useTranslation();

    return (
        <>
            {message &&
                <div className={`settings-sync-cal__notification ${type}`}>
                    <i className={type === 'error' ? 'icon-Error-warning' : type === 'warning' ? 'icon-circle-flight' : ''} />
                    <p>{message}</p>
                    {(type === 'warning' && errorCode !== notificationCodes.WARNINGDEACTIVATED) &&
                        <span className='settings-sync-cal__clear-notification-label' onClick={() => { onClearNotification(); }}>
                            {t('settingsScreen.clearNotification')}</span>}
                </div>
            }
        </>

    );
}
